import { type AxiosInstance } from "axios";
import { type AuthorizeUrlResponse } from "@/features/salesforceIntegration/types";

/**
 * Salesforce認可URLを払い出す（`GET /salesforce/oauth/authorize-url/`）。
 * 取得したURLへ画面全体を遷移させ、Salesforceの認可画面を表示する。
 */
export const getAuthorizeUrl = async (
  apiClient: AxiosInstance
): Promise<AuthorizeUrlResponse> => {
  const { data } = await apiClient.get<AuthorizeUrlResponse>(
    "/salesforce/oauth/authorize-url/"
  );
  return data;
};
